export const PACKAGES = [
  {
    id: "little-magic",
    name: "A Little Magic",
    price: 4500,
    tag: "A sweet little surprise",
    description:
      "A cozy family night, wrapped up with a little North Pole wonder.",
    contents: [
      "Family date-night activity",
      "Popcorn & candy canes",
      "Apple cider",
      "Christmas coloring tablecloth",
      "Santa letter",
    ],
    illustration: "little",
    includedChildren: 2,
  },
  {
    id: "merry-bright",
    name: "Merry & Bright",
    price: 7000,
    tag: "A little more merry",
    description:
      "All the cozy essentials, with extra little surprises for the kids.",
    contents: [
      "Everything in A Little Magic",
      "Squishy surprises",
      "Festive family socks",
      "More Christmas cheer",
    ],
    illustration: "merry",
    includedChildren: 4,
    featured: true,
  },
  {
    id: "christmas-works",
    name: "The Christmas Works",
    price: 10000,
    tag: "The whole Christmas feeling",
    description:
      "Our fullest bundle of together-time, treats, and Christmas memories.",
    contents: [
      "Everything in Merry & Bright",
      "Santa building activity",
      "Christmas cocoa cups & hot cocoa",
      "A Christmas storybook",
    ],
    illustration: "works",
    includedChildren: 6,
  },
  {
    id: "santa-letter",
    kind: "letter",
    name: "A Letter from Santa",
    price: 500,
    tag: "Just the letter",
    description:
      "A personal reply from Santa for each child, written from their own letter and delivered to your door.",
    contents: [
      "A personal letter from Santa",
      "Written from your child’s own letter",
      "Delivered to your doorstep",
    ],
    illustration: "letter",
    includedChildren: 1,
    extraChildPrice: 500,
  },
];

export const EXTRA_CHILD_PRICE = 200;
export const TOWNS = ["Idaho Falls", "Ammon", "Shelley", "Rigby"];
export const DEFAULT_SETTINGS = {
  ordersOpen: true,
  deadline: "2026-12-05T07:00:00.000Z",
  deliveryStart: "2026-12-06",
  deliveryEnd: "2026-12-12",
  contactEmail: "whimsydelivered@gmail.com",
  locations: [
    {
      name: "The Playhut",
      address: "1594 W Broadway St, Idaho Falls, ID 83402",
      hours: "November 5",
    },
  ],
};
// Placeholder artwork notice; remove once real basket photos replace it.
export const ART_DISCLAIMER =
  "Illustration only. Your real basket won’t look exactly like this picture.";

export const money = (cents) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: cents % 100 ? 2 : 0,
  }).format(cents / 100);
export const extraChildren = (item) => {
  const pack = PACKAGES.find((p) => p.id === item.packageId);
  return Math.max(0, item.children.length - pack.includedChildren);
};
export const extraChildPrice = (pack) =>
  pack.extraChildPrice ?? EXTRA_CHILD_PRICE;
export const linePrice = (item) => {
  const pack = PACKAGES.find((p) => p.id === item.packageId);
  return pack.price + extraChildren(item) * extraChildPrice(pack);
};
// Letters are priced per child; baskets include some children plus paid extras.
export const priceSummary = (pack) =>
  pack.kind === "letter"
    ? `${money(pack.price)} per child`
    : `${pack.includedChildren} children included · +${money(extraChildPrice(pack))} per additional child`;
export const lineBreakdown = (item) => {
  const pack = PACKAGES.find((p) => p.id === item.packageId);
  const n = item.children.length,
    extra = extraChildren(item);
  if (pack.kind === "letter")
    return `${n} ${n === 1 ? "letter" : "letters"} × ${money(pack.price)}`;
  return `${money(pack.price)} package${extra ? ` + ${extra} extra ${extra === 1 ? "child" : "children"} × ${money(extraChildPrice(pack))}` : ""}`;
};
export const mapUrl = (location) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${location.name}, ${location.address}`,
  )}`;
export const cartPrice = (items) =>
  items.reduce((total, item) => total + linePrice(item), 0);
export const orderingOpen = (settings, now = new Date()) =>
  settings.ordersOpen && now.getTime() < new Date(settings.deadline).getTime();
